import { InvalidFieldValue } from '../../../../templateeditor/components/FieldValidations/constants';
import { FormEditorState } from '../../../formeditor-types';

export function getInvalidFieldValues(state: FormEditorState): InvalidFieldValue[] {
  const { invalidFieldValues = [], form } = state;
  const formValues = form?.values ?? [];

  const formValueMap = new Map(formValues.map((fv) => [fv.fieldId, fv.value]));

  return invalidFieldValues.filter((field) => {
    const fieldValue = formValueMap.get(field.fieldId);
    return !!fieldValue;
  });
}
